/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/react'

import Logo from '../svg/Logo'
import theme from '../../theme'

const PublicViewsFooter: React.FC = () => {
  return (
    <div css={{ backgroundColor: theme.colors.grayBg2, padding: '2em' }}>
      <ul
        css={{
          listStyleType: 'none',
          margin: '2em 0px',
          padding: '0px',
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          fontFamily: theme.fonts.families.body,
          '& li': {
            display: 'inline-block',
            marginRight: '1.5em',
            marginLeft: '1.5em',
            whiteSpace: 'nowrap',
            '& a': {
              fontFamily: theme.fonts.families.body,
              textDecoration: 'none',
              fontSize: '14px',
              letterSpacing: '0.35px',
              lineHeight: '18px',
              color: theme.colors.text,
              ':hover': {
                textDecoration: 'underline',
              },
            },
          },
        }}
      >
        <li>
          <a href="https://projects.theartling.com/en/">About Us</a>
        </li>
        <li>
          <a href="https://faqs.projects.theartling.com/" target="_blank">
            FAQs
          </a>
        </li>
        <li>
          <a href="https://theartling.com/en/info/contact/" target="_blank">
            Contact Us
          </a>
        </li>
        <li>
          <a
            href="https://theartling.com/en/info/privacy-policy/"
            target="_blank"
          >
            Privacy Policy
          </a>
        </li>
        <li>
          <a
            href="https://theartling.com/en/info/terms-of-use/"
            target="_blank"
          >
            Terms of Use
          </a>
        </li>
      </ul>
      <div css={{ textAlign: 'center', marginBottom: '100px' }}>
        <Logo width="98px" publicLink={true} />
      </div>
    </div>
  )
}

export default PublicViewsFooter
